import React from 'react';
import me from '../images/me.png'
import './Banner.css'
import { ReactComponent as FB } from '../images/fb_icon.svg';
import { ReactComponent as Github } from '../images/github_icon.svg';
import { ReactComponent as Instagram } from '../images/instagram_icon.svg';
import { ReactComponent as Linkedin } from '../images/linkedin_icon.svg';
import { ReactComponent as Twitter } from '../images/twitter_icon.svg';
import  Download from '../images/download-icon.ico';

const Banner = () => {
    
    
    return (
        <div className="hero mt-10 " id='banner'>
            <div className="hero-content flex-col-reverse lg:flex-row-reverse w-full gap-40">
                <img data-aos="flip-left" src={me} className="max-w-sm border-4 border-neutral basis-1/2 profile" alt='' />
                <div className='basis-1/2 '>
                    <h1 className="text-xl font-bold text-neutral">Hi There,</h1>
                    <h1 className="text-3xl lg:text-5xl my-8 text-white ">I Am <span className='font-bold  px-2 animation'>Najmul Hossain</span> </h1>
                    <p className='text-white'>I'm a Front-End Developer.
                        I have serious passion for UI effects, animations and creating intuitive, dynamic user experiences.
                        <br />
                        Let's make something special.</p>
                    <div data-aos="fade-right"  className='flex gap-5 lg:my-5 icons'>
                        <a target='blank' href="https://web.facebook.com/najmul.tk16">
                        <FB className='icon' />
                        </a>
                        <a target='blank' href="https://github.com/najmul009">
                        <Github className='icon'/>
                        </a>
                        <a target='blank' href="https://www.instagram.com/nh.sifat/">
                        <Instagram className='icon'/>
                        </a>
                        <a target='blank' href="https://www.linkedin.com/in/najmul-hossain-offficial202/">
                        <Linkedin className='icon'/>
                        </a>
                        <a target='blank' href="https://web.facebook.com/najmul.tk16">
                        <Twitter className='icon'/>
                        </a>
                        
                        
                        
                        
                    </div>
                    <a target='blank' href="https://drive.google.com/file/d/17UILPFpA3456Jh-pO2Dxmuz_95tWXESG/view?usp=sharing">
                    <button className='btn btn-neutral rounded-full px-5'>Resume <img className='w-5 ml-3' src={Download} alt="" /> </button>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Banner;